module.exports = __webpack_public_path__ + "images/emoji/part_alternation_mark.6b0e1e40e7a8a66f8e4a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/part_alternation_mark.png
// module id = ky/L
// module chunks = 2